import { usePage } from "@inertiajs/react"
import { motion } from "framer-motion"
import { FlashMessages } from "@/components/FlashMessages"
import { Toaster } from "@/components/ui/sonner"

import { AppSidebar } from "@/components/nav/app-sidebar"
import { cn, getCookie } from "@/lib/utils"
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"
import { Separator } from "@/components/ui/separator"
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar"

export function Layout({ children, insetClassName }) {
  const { current_user, current_workspace } = usePage()
  const sidebarState = getCookie("sidebar_state")
  const defaultOpen = sidebarState !== "false"

  return (
    <>
      <Toaster />
      <FlashMessages />
      <SidebarProvider defaultOpen={defaultOpen} className="h-svh overflow-hidden">
        <AppSidebar />
        <SidebarInset className={cn("min-w-0 min-h-0 overflow-hidden", insetClassName)}>
          <motion.div
            className="flex flex-col flex-1 min-h-0"
            initial={{ opacity: 0, x: 10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 30, bounce: 0, restDelta: 0.01 }}
          >
            {children}
          </motion.div>
        </SidebarInset>
      </SidebarProvider>
    </>
  )
}
